"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = mercurio;
var _chatSdk = _interopRequireDefault(require("@olxbr/chat-sdk"));
var _lurker = _interopRequireDefault(require("../../helpers/lurker"));
var _tracker = _interopRequireDefault(require("../../helpers/tracker"));
var _dataLayer = _interopRequireDefault(require("../../helpers/dataLayer"));
var _currentVersion = require("../../helpers/currentVersion");
var _selectors = require("../../selectors");
var _env = _interopRequireDefault(require("../../helpers/env"));
var _netinfo = _interopRequireDefault(require("../../helpers/netinfo"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function mountUserId(userId) {
  if (_env["default"].isAuthTypeKong()) {
    return 'new_flow';
  }
  if (!userId) {
    // eslint-disable-next-line no-console
    console.error('OLX: Missing user id for current auth flow type!');
  }
  return userId;
}
function appendParameterToUrl(url, key, value) {
  var constainsQuestionMark = url.indexOf('?') !== -1;
  return constainsQuestionMark ? "".concat(url, "&").concat(key, "=").concat(value) : "".concat(url, "?").concat(key, "=").concat(value);
}
var mountWebsocketURL = function mountWebsocketURL() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var publisherId = arguments.length > 1 ? arguments[1] : undefined;
  var result = url;
  if (_env["default"].isAuthTypeKong()) {
    result = appendParameterToUrl(result, 'auth', 'kong');
  }
  if (publisherId) {
    result = appendParameterToUrl(result, 'publisherId', publisherId);
  }
  return result;
};
var optionsDefaults = {
  // Used for mocking chat-sdk (jaiminho) in tests
  chatSDK: null,
  // Used for mocking lurker in tests
  lurker: null,
  // Used for mocking lurker in tests
  tracker: null
};
function mercurio(renderProps) {
  var optionsOverrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var listId = renderProps.listId,
    resource = renderProps.resource,
    token = renderProps.token,
    user = renderProps.user,
    _renderProps$deviceId = renderProps.deviceId,
    deviceId = _renderProps$deviceId === void 0 ? null : _renderProps$deviceId,
    _renderProps$mercurio = renderProps.mercurioUrl,
    mercurioUrl = _renderProps$mercurio === void 0 ? _env["default"].getMercurioBaseUrl() : _renderProps$mercurio,
    publisherId = renderProps.publisherId;
  var options = Object.assign({}, optionsDefaults, optionsOverrides);
  var shouldAutoLoadRooms = !listId;
  var increaseTimeout60 = false;
  var shouldFetchInactiveAds = true;
  var chatSDK = options.chatSDK || new _chatSdk["default"](mountUserId(user), token, 'olxbr', resource, mountWebsocketURL(mercurioUrl, publisherId), _netinfo["default"], shouldAutoLoadRooms, increaseTimeout60, shouldFetchInactiveAds, deviceId);
  var extraArgument = {
    ChatSDK: chatSDK,
    DataLayer: _dataLayer["default"]
  };
  return function (_ref) {
    var dispatch = _ref.dispatch,
      getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          var chat = (0, _selectors.getCurrentChat)(getState());
          var currentRenderProps = (0, _selectors.getRenderProps)(getState());
          var currentListId = currentRenderProps.listId,
            currentUser = currentRenderProps.user;
          var lurker = options.lurker || new _lurker["default"](chat, currentUser, currentListId, _currentVersion.currentVersion, currentRenderProps);
          var tracker = options.tracker || new _tracker["default"](chat, currentUser, currentListId, _currentVersion.currentVersion, currentRenderProps);
          return action(dispatch, getState, _objectSpread(_objectSpread({}, extraArgument), {}, {
            Lurker: lurker,
            Tracker: tracker,
            RenderProps: _objectSpread(_objectSpread({}, renderProps), currentRenderProps)
          }));
        }
        return next(action);
      };
    };
  };
}